import React from 'react';
import { Route } from 'react-router-dom';
import { List, Show } from '../components/product/';
import '../products.css';

export default [
  <Route path="/public/product/:id" component={Show} exact key="show" />,
  <Route path="/public/products/" component={List} exact strict key="list" />,
  <Route path="/public/products/:page" component={List} exact strict key="page" />
];
